import { combineReducers } from "redux";

import user from "../User";
import userGroup from "../UserGroup";

const Admin = combineReducers({
  user,
  userGroup
});

export default Admin;
